import { Navigate, Route, Routes } from "react-router-dom";
import { SessionGate } from "./components/SessionGate";
import { Documents } from "./pages/Documents";
import { Search } from "./pages/Search";
import { DocumentDetail } from "./pages/DocumentDetail";
import { Jobs } from "./pages/Jobs";
import { Webhooks } from "./pages/Webhooks";
import { Review } from "./pages/Review";
import { Collections } from "./pages/Collections";
import { Templates } from "./pages/Templates";
import { TemplateDetail } from "./pages/TemplateDetail";
import { FillDetail } from "./pages/FillDetail";
import { CollectionDetail } from "./pages/CollectionDetail";
import { Tags } from "./pages/Tags";
import { NotBuilt } from "./pages/NotBuilt";
import { Login } from "./pages/Login";
import { AcceptInvite } from "./pages/AcceptInvite";
import { Users } from "./pages/Users";
import { Keys } from "./pages/Keys";
import { Audit } from "./pages/Audit";
import { Retention } from "./pages/Retention";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/documents" replace />} />
      <Route path="/documents" element={<Documents />} />
      <Route path="/search" element={<Search />} />
      <Route path="/documents/:id" element={<DocumentDetail />} />
      <Route path="/jobs" element={<Jobs />} />
      <Route path="/webhooks" element={<Webhooks />} />
      <Route
        path="/schemas"
        element={
          <NotBuilt
            n="04"
            title="Schemas"
            what="Your own extraction fields — name, type, whether it is required — filled by a small local model reading the text this parser already produced, instead of one fixed schema. Money fields still go through the three-way cell, so a blank stays unknown rather than becoming zero."
          />
        }
      />
      <Route
        path="/workflows"
        element={
          <NotBuilt
            n="05"
            title="Workflows"
            what="Chained processors over a versioned graph: split a mixed file into its parts, extract against a schema, validate, route on a condition, merge branches, pause for a human, deliver. Drafts stay editable; published versions do not change under a running job."
          />
        }
      />
      <Route path="/review" element={<Review />} />
      <Route path="/templates" element={<Templates />} />
      <Route path="/templates/:id" element={<TemplateDetail />} />
      <Route path="/fills/:id" element={<FillDetail />} />
      <Route path="/collections" element={<Collections />} />
      <Route path="/collections/:id" element={<CollectionDetail />} />
      <Route path="/tags" element={<Tags />} />
      <Route path="/settings/users" element={<Users />} />
      <Route path="/settings/keys" element={<Keys />} />
      <Route path="/settings/audit" element={<Audit />} />
      <Route path="/settings/retention" element={<Retention />} />
      <Route path="*" element={<Navigate to="/documents" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/invites/accept" element={<AcceptInvite />} />
      <Route
        path="*"
        element={
          <SessionGate>
            <AppRoutes />
          </SessionGate>
        }
      />
    </Routes>
  );
}
